// extracted by mini-css-extract-plugin
export default {"highRisk":"#aa001a","mediumRisk":"#ff891c","lowRisk":"#006a42","pepsicoSite":"#29458e"};